import { gql } from '@apollo/client'

const CREATE_COMPANY = gql`
  mutation createCompany(
    $companyName: String!
    $tvaNumber: TvaNumber!
    $siret: SiretNumber!
  ) {
    createCompany(
      input: {
        company: { name: $companyName, tvaNumber: $tvaNumber, siret: $siret }
      }
    ) {
      clientMutationId
      company {
        id
      }
    }
  }
`

export default CREATE_COMPANY
